import DashboardIcon from "@mui/icons-material/Dashboard";
import CategoryIcon from "@mui/icons-material/Category";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import HistoryIcon from "@mui/icons-material/History";
import BarChartIcon from "@mui/icons-material/BarChart";
import PersonIcon from "@mui/icons-material/Person";
import type { SvgIconComponent } from "@mui/icons-material";

export const DRAWER_WIDTH = 256;

/** Viewport breakpoint (MUI `md` = 900px): persistent sidebar + no top bar. Below: drawer + app bar. */
export const NAV_DESKTOP_UP = "md" as const;

export interface NavItem {
  label: string;
  i18nKey: string;
  path: string;
  icon: SvgIconComponent;
  requiresAuth: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: "Dashboard",
    i18nKey: "nav.dashboard",
    path: "/dashboard",
    icon: DashboardIcon,
    requiresAuth: true,
  },
  {
    label: "Categories",
    i18nKey: "nav.categories",
    path: "/categories",
    icon: CategoryIcon,
    requiresAuth: true,
  },
  {
    label: "Restaurants",
    i18nKey: "nav.restaurants",
    path: "/restaurants",
    icon: RestaurantIcon,
    requiresAuth: true,
  },
  {
    label: "History",
    i18nKey: "nav.history",
    path: "/history",
    icon: HistoryIcon,
    requiresAuth: true,
  },
  {
    label: "Analytics",
    i18nKey: "nav.analytics",
    path: "/analytics",
    icon: BarChartIcon,
    requiresAuth: true,
  },
  {
    label: "Account",
    i18nKey: "nav.account",
    path: "/account",
    icon: PersonIcon,
    requiresAuth: true,
  },
];
